var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { Vue, Component, Prop, Watch } from "vue-property-decorator";
import FormGroup from "../Components/FormGroup.vue";
var ChangePassword = /** @class */ (function (_super) {
    __extends(ChangePassword, _super);
    function ChangePassword() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.localPassword = _this.password || null;
        _this.localNewPassword = _this.newPassword || null;
        _this.localConfirmPassword = _this.confirmPassword || null;
        return _this;
    }
    ChangePassword.prototype.onPasswordChanged = function (val) { this.$emit("update:password", val); };
    ChangePassword.prototype.onNewPasswordChanged = function (val) { this.$emit("update:newPassword", val); };
    ChangePassword.prototype.onConfirmPasswordChanged = function (val) { this.$emit("update:confirmPassword", val); };
    __decorate([
        Prop({ type: Boolean, default: false })
    ], ChangePassword.prototype, "change", void 0);
    __decorate([
        Prop({ type: Object, required: true })
    ], ChangePassword.prototype, "metadata", void 0);
    __decorate([
        Prop({ type: Object, required: true })
    ], ChangePassword.prototype, "$v", void 0);
    __decorate([
        Prop({ type: String })
    ], ChangePassword.prototype, "password", void 0);
    __decorate([
        Watch("localPassword")
    ], ChangePassword.prototype, "onPasswordChanged", null);
    __decorate([
        Prop({ type: String, default: "password" })
    ], ChangePassword.prototype, "mPassword", void 0);
    __decorate([
        Prop({ type: String, default: "password" })
    ], ChangePassword.prototype, "$vPassword", void 0);
    __decorate([
        Prop({ type: String })
    ], ChangePassword.prototype, "newPassword", void 0);
    __decorate([
        Watch("localNewPassword")
    ], ChangePassword.prototype, "onNewPasswordChanged", null);
    __decorate([
        Prop({ type: String, default: "newPassword" })
    ], ChangePassword.prototype, "mNewPassword", void 0);
    __decorate([
        Prop({ type: String, default: "newPassword" })
    ], ChangePassword.prototype, "$vNewPassword", void 0);
    __decorate([
        Prop({ type: String })
    ], ChangePassword.prototype, "confirmPassword", void 0);
    __decorate([
        Watch("localConfirmPassword")
    ], ChangePassword.prototype, "onConfirmPasswordChanged", null);
    __decorate([
        Prop({ type: String, default: "confirmPassword" })
    ], ChangePassword.prototype, "mConfirmPassword", void 0);
    __decorate([
        Prop({ type: String, default: "confirmPassword" })
    ], ChangePassword.prototype, "$vConfirmPassword", void 0);
    ChangePassword = __decorate([
        Component({
            name: "ChangePassword",
            components: {
                FormGroup: FormGroup
            }
        })
    ], ChangePassword);
    return ChangePassword;
}(Vue));
export default ChangePassword;
;



//////////////////
// WEBPACK FOOTER
// ./node_modules/ts-loader!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/Account/ChangePassword.vue
// module id = 247
// module chunks = 6 12